import "./polyfills";
import React from "react";
import ReactDOM from "react-dom/client";
import { WagmiProvider } from "wagmi";
import { EntryKitProvider, defineConfig } from "@latticexyz/entrykit/internal";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./style.css";
import { RouterProvider } from "react-router-dom";
import { wagmiConfig } from "./wagmiConfig";
import { router } from "./router";
import { contract } from "./contract";

const queryClient = new QueryClient();

const rootElement = document.getElementById("react-root");
if (!rootElement) throw new Error("React root not found");
const root = ReactDOM.createRoot(rootElement);

root.render(
  <WagmiProvider config={wagmiConfig}>
    <QueryClientProvider client={queryClient}>
      <EntryKitProvider
        config={defineConfig({
          chainId: contract.chain.id,
          worldAddress: contract.address,
          theme: "dark",
        })}
      >
        <RouterProvider router={router} />
      </EntryKitProvider>
    </QueryClientProvider>
  </WagmiProvider>,
);
